/**
 * 添加千分位
 * @param n
 * @returns {*}
 */
export function comdify(n) {
  if (n === undefined || n === null) {
    n = ''
  }
  if (!isNaN(n)) {
    n = n + ''
  }
  var re = /\d{1,3}(?=(\d{3})+$)/g
  var n1 = n.replace(/^(\d+)((\.\d+)?)$/, function(s, s1, s2) {
    return s1.replace(re, '$&,') + s2
  })
  return n1
}
export function returnFloat(value) {
  var temp = Math.round(parseFloat(value) * 100) / 100
  var xsd = temp.toString().split('.')
  if (xsd.length === 1) {
    temp = (isNaN(temp) ? '0' : temp.toString()) + '.00'
    return temp
  }
  if (xsd.length > 1) {
    if (xsd[1].length < 2) {
      temp = temp.toString() + '0'
    }
    return temp
  }
}

export function numberFormat4(value) {
  var temp = Math.round(parseFloat(value) * 100) / 100
  var xsd = temp.toString().split('.')
  if (xsd.length === 1) {
    temp = (isNaN(temp) ? '0' : temp.toString()) + '.0000'
    return temp
  }
  if (xsd.length > 1) {
    for (var i = 0; i < (4 - xsd[1].length); i++) {
      temp = temp.toString() + '0'
    }
    return temp
  }
}
